export const URLify = (s) => {
  return s.replace(/\s/g, '_')
}

export const deURLify = (s) => {
  return s.replace(/_/g, ' ')
}